export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5025/api';
export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || 'http://localhost:5025/';
export const SOCKET_SERVER = process.env.REACT_APP_SOCKET_URL || 'http://localhost:5999/socket';
export const JWT_SECRET = '123456';
export const REACT_APP_STATUS = process.env.REACT_APP_STATUS || 'offline';
export const REACT_APP_STATUS_COLOR = process.env.REACT_APP_STATUS_COLOR || 'red';
export const REACT_APP_GOOGLE_MAPS_API = process.env.REACT_APP_GOOGLE_MAPS_API || '123456';
export const API_KEY = process.env.REACT_APP_API_KEY;
export const USER_SECRET = process.env.REACT_APP_USER_SECRET;
export const INTERCOM_SERVICE_URL = process.env.REACT_APP_CONVERSATIONS_SERVICE || 'http://localhost:5004';
export const APP_URL = process.env.REACT_APP_APP_URL || 'http://localhost:3001';
export const IDENTITY_APP_URL = process.env.REACT_APP_IDENTITY_APP_URL || 'http://localhost:3002';
export const GATEKEEPER_URL = process.env.REACT_APP_GATEKEEPER_URL || 'http://localhost:3000';